import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { isSuperAdmin } from '@/utils/permission'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/pages/Dashboard.vue')
      },
      {
        path: 'import-sales',
        name: 'ImportSales',
        component: () => import('@/pages/ImportSalesData.vue')
      },
      {
        path: 'payments/import',
        name: 'PaymentImport',
        component: () => import('@/pages/PaymentImport.vue')
      },
      {
        path: 'admin/users',
        name: 'UserManagement',
        component: () => import('@/pages/UserManagement.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/users/:userId/customers',
        name: 'CustomerAssignment',
        component: () => import('@/pages/CustomerAssignment.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/roles',
        name: 'RoleConfig',
        component: () => import('@/pages/RoleConfig.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/customer-assign',
        name: 'CustomerAssign',
        component: () => import('@/pages/CustomerAssign.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/customers',
        name: 'CustomerManagement',
        component: () => import('@/pages/CustomerManagement.vue'),
        meta: { requiresSuperAdmin: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  if (!authStore.token && to.path !== '/login') {
    next('/login')
    return
  }

  if (to.meta.requiresSuperAdmin) {
    if (!authStore.user || !isSuperAdmin(authStore.user.role)) {
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
